import { Paper, Typography } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React from "react";
import { EventNotification } from "../../domain/EventNotification";
import { SectionProps } from "../sections/SectionProps";
import { InherentRisk } from "../sections/InherentRisk";
import { ResidualRisk } from "../sections/ResidualRisk";
import { SummaryOfqual } from "../sections/SummaryOfqual";
import { TypeOfQualification } from "../sections/TypeOfQualification";
import { Directorate } from "../sections/Directorate";
import { Cause } from "../sections/Cause";
import { OfqualFollowUpDate } from "../sections/OfqualFollowUpDate";
import { Analysis } from "../sections/Analysis";
import { Risk } from "../sections/Risk";
import { useAuth } from "@ofqual/portal-core/core/hooks";
import { authSelector } from "../../redux/selectors";
import { ConditionsEnhancedGcor } from "../sections/ConditionsEnhancedGcor";


const useStyles = makeStyles((theme) => ({
  formHeading: {
    color: "#9f9f9f",
    fontSize: "1em",
    marginBottom: "30px",
    fontWeight: 600,
    position: "relative",
  },
  formSection: {
    padding: 30,
    boxShadow: "0 0 19px -2px hsla(0,0%,63.9%,.3)",
    border: "1px solid #ddd",
    backgroundColor: "#fff",
    borderRadius: "3px",
  },
}));

export const ItemDetailsOfqual: React.FC<{
  sectionProps: SectionProps<EventNotification>;
}> = ({ sectionProps }) => {

  const { experimentalFeatures } = useAuth(authSelector);
  const enhancedGcor =  experimentalFeatures.find(x => x.moduleName === "portal-comms" && x.featureName === "portal-comms-gcor") ? true : false;

  const propsIndicated = { ...sectionProps, 
    generalCondition: "enOfqualIndicatedNonComplianceGeneralCondition", 
    generalSubCondition: "enOfqualIndicatedNonComplianceGeneralSubCondition",
    qualCondition: "enOfqualIndicatedNonComplianceQualCondition",
    subjectCondition : "enOfqualIndicatedNonComplianceSubjectCondition" };


  const propsNoncomp = { ...sectionProps, 
    generalCondition: "enOfqualNonComplianceGeneralCondition", 
    generalSubCondition: "enOfqualNonComplianceGeneralSubCondition",
    qualCondition: "enOfqualNonComplianceQualCondition",
    subjectCondition : "enOfqualNonComplianceSubjectCondition" };

  const propsLegacy = { ...sectionProps, 
    generalCondition: "eventNotificationIndicatedNonComplianceGeneralCondition", 
    generalSubCondition: "eventNotificationIndicatedNonComplianceGeneralSubCondition",
    qualCondition: "eventNotificationIndicatedNonComplianceQualCondition",
    subjectCondition : "eventNotificationIndicatedNonComplianceSubjectCondition"
  };
  

  const classes = useStyles();
  return (
    <>
      <div>
        <form>
          <Typography variant="h6">Inherent Risk</Typography>
          <Paper className={classes.formSection}>
            <InherentRisk {...sectionProps} />
          </Paper>

          <Typography variant="h6">Residual Risk</Typography>
          <Paper className={classes.formSection}>
            <ResidualRisk {...sectionProps} />
          </Paper>

          <Typography variant="h6">Risk</Typography>
          <Paper className={classes.formSection}>
            <Risk {...sectionProps} />
          </Paper>

          <Typography variant="h6">Summary</Typography>
          <Paper className={classes.formSection}>
            <SummaryOfqual {...sectionProps} />
          </Paper>

          <Typography variant="h6">Type of Qualification</Typography>
          <Paper className={classes.formSection}>
            <TypeOfQualification {...sectionProps} />
          </Paper>

          <Typography variant="h6">Directorate</Typography>
          <Paper className={classes.formSection}>
            <Directorate {...sectionProps} />
          </Paper>

          {/* <h6 className={classes.formHeading}>Sector Subject Areas</h6>
          <Paper className={classes.formSection}></Paper> */}

          <Typography variant="h6">Cause</Typography>
          <Paper className={classes.formSection}>
            <Cause {...sectionProps} />
          </Paper>

          <Typography variant="h6">Ofqual Follow Up Date</Typography>
          <Paper className={classes.formSection}>
            <OfqualFollowUpDate {...sectionProps} />
          </Paper>

          <Typography variant="h6">Analysis</Typography>
          <Paper className={classes.formSection}>
            <Analysis {...sectionProps} />
          </Paper>

          {enhancedGcor ? (
            <div>
            <Typography variant="h6">
              Indications of non-compliance against the following conditions
            </Typography>
            <Paper className={classes.formSection}>
              <ConditionsEnhancedGcor {...propsIndicated} />
            </Paper>
            <Typography variant="h6">
              Non-compliance against the following conditions
            </Typography>
            <Paper className={classes.formSection}>
              <ConditionsEnhancedGcor {...propsNoncomp} />
            </Paper>
            </div>) : 
            (
            <div>
            <Typography variant="h6">
              Non-compliance or indications of non-compliance against the
              following conditions
            </Typography>
            <Paper className={classes.formSection}>
              <ConditionsEnhancedGcor {...propsLegacy} />
            </Paper>
            </div>)}

        </form>
      </div>
    </>
  );
};
